import React from 'react';
import { Formik } from 'formik';
import { userStore } from '../../stores';
import { MimaButton, MimaInput } from '../../components';

const StageTwo = ({ loading, validationSchema, onSubmit }) => {
	return (
		<Formik
			initialValues={{
				bvn: '',
				regNo: '',
				mobile: userStore.user.mobile,
				fullname: `${userStore.user.firstname} ${userStore.user.middlename || ''}${userStore.user.lastname}`,
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				values,
				errors,
				touched,
			}) => (
				<div>
					<MimaInput
						type="text"
						labelTitle="Fullname"
						name="fullname"
						id="fullname"
						value={values.fullname}
						onChange={handleChange}
						error={errors.fullname}
						touched={touched.fullname}
						onBlur={handleBlur}
					/>
					<MimaInput
						type="text"
						labelTitle="Personal Phone Number"
						name="mobile"
						id="mobile"
						value={values.mobile}
						onChange={handleChange}
						error={errors.mobile}
						touched={touched.mobile}
						onBlur={handleBlur}
					/>
					<MimaInput
						type="text"
						labelTitle="Bank Verification Number(BVN)"
						placeholder="BVN"
						name="bvn"
						id="bvn"
						value={values.bvn}
						onChange={handleChange}
						onBlur={handleBlur}
						touched={touched.bvn}
						error={errors.bvn}
					/>
					<MimaInput
						type="text"
						labelTitle="Business Registration Number(optional)"
						placeholder="RC 12345678"
						name="regNo"
						id="regNo"
						value={values.regNo}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<MimaButton
						title="Continue"
						onClick={handleSubmit}
						variant="form"
						loading={loading}
					/>
				</div>
			)}
		</Formik>
	);
};

export default StageTwo;
